// extracted by mini-css-extract-plugin
module.exports = {"root":"MarketMatchingModal_root__S2TNU","open":"MarketMatchingModal_open__evd2l","modal":"MarketMatchingModal_modal__avwsD"};